import { CommentLanguageIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';

interface Props {
  languages: string[];
}

function ExperienceAvailableLanguages({ languages }: Props) {
  return (
    <div className="flex items-center gap-x-2">
      <CommentLanguageIcon size="md" />
      <Typography variant="caption">
        <T
          kind="Available in <span>{{languages}}</span>"
          languages={languages.join(', ')}
          span={(languages) => <>{languages}</>}
        />
      </Typography>
    </div>
  );
}
export default observer(ExperienceAvailableLanguages);
